var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.834,
    cy: 21.5,
    r: 21.5,
    fill: "#FF9431"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4277 18.3949C25.2559 18.7419 26.0023 19.25 26.6256 19.8819C27.8523 21.1246 28.6107 22.8406 28.6107 24.7369C28.6104 28.5267 25.5763 31.6004 21.8345 31.6004C18.0907 31.6004 15.0576 28.5267 15.0576 24.7369C15.0576 22.8406 15.817 21.1246 17.0427 19.8819C18.366 18.542 19.0277 16.785 19.0277 15.0277C19.0277 14.097 18.8424 13.2097 18.511 12.4004C21.2026 14.223 21.9274 17.9115 20.1288 20.6382C19.9596 20.895 19.8787 21.1854 19.8797 21.4731C19.8809 21.9558 20.1108 22.4288 20.5373 22.7175C21.2167 23.1774 22.1359 22.9916 22.59 22.3033C22.8096 21.9704 22.9135 21.5953 22.9169 21.2233C22.9222 20.5782 22.6193 19.9424 22.05 19.5572C23.7281 20.2616 24.7037 21.9531 24.601 23.6917C25.9181 22.1672 25.8627 19.8493 24.4277 18.3949Z",
    stroke: "#FCFCFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1936 15.0985C24.7828 14.2059 24.5455 12.9975 23.6639 12.4004C23.6637 12.8984 23.476 13.3966 23.1014 13.7761C22.3516 14.5357 22.3516 15.7676 23.1014 16.527C23.2975 16.7254 23.5365 16.8795 23.8017 16.9767C23.6949 16.3458 23.8142 15.6735 24.1936 15.0985Z",
    stroke: "#FCFCFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalories);
export default __webpack_public_path__ + "static/media/calories.28e75b415bbc93c7a68e6288b88750de.svg";
export { ForwardRef as ReactComponent };